/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersTenantResponseDto } from '../../models/users-tenant-response-dto';

export interface TenantsControllerFindByName$Params {

/**
 * The name of the tenant to retrieve.
 */
  name: string;
}

export function tenantsControllerFindByName(http: HttpClient, rootUrl: string, params: TenantsControllerFindByName$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, tenantsControllerFindByName.PATH, 'get');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersTenantResponseDto>;
    })
  );
}

tenantsControllerFindByName.PATH = '/o2-users/tenants/name/{name}';
